import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

/**
 * Primary UI component for user interaction
 */
export const Button = ({ color, icon, title, onClick, ...props }) => {
  return (
    <div
      data-testid="button-element"
      className={`${styles.pntaButtonStyle} ${
        color === "red"
          ? styles.redButton
          : color === "dark"
          ? styles.darkButton
          : color === "light"
          ? styles.lightButton
          : color === "grey"
          ? styles.greyButton
          : color === "darker"
          ? styles.darkerButton
          : styles.darkButton
      }`}
        onClick={onClick}
    >
      <div>{icon && icon}</div>
      <div className="ButtonTxt">{title}</div>
  </div>
  );
};

Button.propTypes = {
  /**
   * What color scheme to use
   */
  color: PropTypes.oneOf(['red', 'dark', 'light', 'grey', 'darker']),
  /**
   * What icon should be on the button?
   */
  icon: PropTypes.any,
  /**
   * Button contents
   */
  title: PropTypes.string.isRequired,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func,
};

Button.defaultProps = {
  color: 'dark',
  title: 'Button',
  onClick: undefined,
};
